import React, { useEffect, useState } from "react";
import {
  AlertCircle,
  ArrowRight,
  CarFront,
  Cog,
  Copy,
  FileJson,
  Info,
  ListCheck,
  Loader,
  Loader2,
  ShieldCheck,
} from "lucide-react";

import { isAlphanumeric, isNumeric } from "validator";
import { useService } from "../../../../context/ServiceContext";
import { showErrorToast, showSuccessToast } from "../../../../utils/toastUtils";
import { fetchProfile } from "../../../../Services/profile/profileservice";
import Seo from "../../../../Components/SeoComponent/Seo";
import Header from "../../../../Components/Header";
import { getMobileToRcSrv2, getRcToMobileSrv2 } from "../../../../Services/ApiTestService/apiTestService";

function MobileToRcSrv2() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [mobileNo, setMobile] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);
  const { serviceName } = useService();


  const [profileData, setProfileData] = useState(null);
  let apiResponse;

const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const handleMobileToRc = async () => {
    if (!profileData) return;

    const validateMobile = isNumber(mobileNo);

    if ( !mobileNo) {
      return setInputError("Vehicle Number is Required");
    }

    if (mobileNo && !validateMobile) {
      return setInputError("⚠️ Please enter Number Only");
    }
    
    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await getMobileToRcSrv2({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        mobile_number: mobileNo.trim()?.toUpperCase(),
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className="max-w-4xl w-full mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-100">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
              <CarFront size={24} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800">
               {serviceName}
              </h2>
              <p className="text-sm text-slate-500">
                Verify vehicle details using the Mobile number.
              </p>
            </div>
          </div>

          {/* Inputs */}
          <div className="mt-6  gap-6 flex justify-center items-center">
    
            {/* Mobile Number */}
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <Cog size={17} className="text-blue-600" />
                Mobile Number
              </label>

              <input
                type="number"
                value={mobileNo}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Eg: 7858986985"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-3 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>

                {/* Button */}
          <div className="mt-8 flex ">
            <button
              disabled={isLoading || (!mobileNo)}
              onClick={handleMobileToRc}
              className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  Verifying...
                </>
              ) : (
                <>
                  Verify 
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </>
              )}
            </button>
          </div>
          </div>

          {/* Error */}
          {inputError && (
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-700">
              <AlertCircle size={18} />
              <span className="text-sm font-medium">{inputError}</span>
            </div>
          )}

      
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div className="w-full flex justify-center">
          <div className="bg-green-100 max-w-3xl border border-green-400 text-green-700 p-5 mt-12 rounded-2xl">
            <h3 className="font-bold flex items-center justify-start gap-2 text-lg mb-2">
              <Info /> Important Instructions{" "}
              <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid Mobile Number. Clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including contact details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-2" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

            <div className="bg-gray-200 p-2 rounded-md">
              <h2 className="text-2xl flex items-center justify-center gap-2 font-bold text-blue-500 mb-1">
                <ListCheck />
                RC Data
              </h2>

               {response?.status?.code === 200 && response?.data?.vehicleNumbers?.length > 0 && (
  <div className="mb-6 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
    {/* Header Section */}
    <div className="px-5 py-4 border-b border-gray-100 bg-gray-50/50">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider">
        Vehicle Numbers
      </h3>
    </div>
    
    {/* List Section */}
    <div className="p-5">
      <ul className="space-y-1">
        {response.data.vehicleNumbers.map((item, idx) => (
          <li
            key={idx}
            className="flex items-center justify-between py-2.5 border-b border-gray-50 last:border-0 last:pb-0"
          >
            <span className="text-sm font-medium text-gray-500">
              Vehicle {idx + 1}
            </span>
            <span className="text-sm font-semibold text-gray-800 font-mono bg-gray-100 px-3 py-1 rounded-md">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
)}

            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MobileToRcSrv2;